// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__N+9an","current":"Breadcrumb_current__tA3TO","separator":"Breadcrumb_separator__mGx97"};